var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.through)?_c('el-dropdown-item',{attrs:{"divided":_vm.divided,"disabled":_vm.disabled,"icon":_vm.icon},nativeOn:{"click":function($event){return _vm.$emit('click')}}},[_c('el-link',{attrs:{"type":_vm.type,"disabled":_vm.disabled,"underline":false}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }